import React from 'react';
import { useData } from '../../context/DataContext';
import { Select } from '../ui/Select';
export function CompanySelector() {
  const {
    companies,
    selectedCompanyId,
    setSelectedCompanyId
  } = useData();
  const options = companies.map(company => ({
    value: company.id,
    label: company.name
  }));
  return <div className="w-full max-w-xs" data-id="element-67">
      <Select label="Company" options={options} value={selectedCompanyId} onChange={e => setSelectedCompanyId(e.target.value)} data-id="element-68" />
    </div>;
}